import Link from "../Link";

const HtmlCss = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/12" title={"OpenBootcamp HTML y CSS"} />
        </div>
    );
}

export default HtmlCss;